// extracted by mini-css-extract-plugin
export default {"container":"textarea_container__4A7KD","counter":"textarea_counter__-cdDP","limit":"textarea_limit__Ru+pO"};